/**
 * ファイルチェック：実行中
 */
export const RESOURCE_STATUS_CODE_PROCESSING = 1000;
/**
 * ファイルチェック：正常
 */
export const RESOURCE_STATUS_CODE_SUCCESS = 2000;
/**
 * ファイルチェック：処理実行前
 */
export const RESOURCE_STATUS_CODE_BEFORE_PROCESS = 2002;
